import { connect } from "react-redux";
import VirtualStagingOrderModal from "./virtual_staging_order_modal";
import { withRouter } from "react-router-dom";
import { fetchVirtualStagingInfo, createVirtualStagingPurchase } from "../../actions/virtual_staging_actions";
import { fetchCurrentUser } from "../../actions/session_actions";

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  photos: Object.values(state.entities.virtualStaging.photos),
  currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null,
});

const mdp = (dispatch) => ({
  fetchVirtualStagingInfo: (project_id) => dispatch(fetchVirtualStagingInfo(project_id)),
  createVirtualStagingPurchase: (orders) => dispatch(createVirtualStagingPurchase(orders)),
  fetchCurrentUser: (user_id) => dispatch(fetchCurrentUser(user_id)),
});

export default withRouter(connect(msp, mdp)(VirtualStagingOrderModal));
